import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/common/img-pagetop.svg'


const _withScopeId = n => (_pushScopeId("data-v-74899da9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "l-wrapper",
  style: {"background-color":"#e6eff6"}
}
const _hoisted_2 = { class: "l-wrapper_main" }
const _hoisted_3 = { class: "p-recommend --no-pt-sp" }
const _hoisted_4 = { class: "p-recommend-nav" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("転職希望"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("アンケート")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "書類作成", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "書類提出", -1))
const _hoisted_8 = { class: "p-recommend-inner" }
const _hoisted_9 = { class: "p-recommend-group-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "p-recommend-heading-1" }, "書類提出", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-text-1" }, "プロフィールに入力した内容で応募書類の提出ができます。", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-text-2 --color-3" }, [
  /*#__PURE__*/_createTextVNode(" ※ダウンロード時の注意"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("スマートフォン・タブレットでご利用の場合、OS・ブラウザ・機種依存などによって、正常な動作や表示ができない場合がございます。また、編集する際は必要に応じてアプリのインストールをお願いいたします。 ")
], -1))
const _hoisted_13 = { class: "p-recommend-group-3 --mt-1" }
const _hoisted_14 = { class: "p-recommend-group-3__set" }
const _hoisted_15 = { class: "p-recommend-group-3__set-head" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-heading-2 --no-mb" }, "履歴書", -1))
const _hoisted_17 = { class: "p-recommend-download-group" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-download-group__text" }, "履歴書のダウンロード", -1))
const _hoisted_19 = { class: "p-recommend-download-group__buttons" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Excel", -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "PDF", -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "履歴書を提出する", -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "p-recommend-text-2 --align-right --color-3" }
const _hoisted_27 = { class: "p-recommend-group-3__set" }
const _hoisted_28 = { class: "p-recommend-group-3__set-head" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-heading-2 --no-mb" }, "職務経歴書", -1))
const _hoisted_30 = { class: "p-recommend-download-group" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-download-group__text" }, "職務経歴書のダウンロード", -1))
const _hoisted_32 = { class: "p-recommend-download-group__buttons" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Word", -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "PDF", -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "職務経歴書を提出する", -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = { class: "p-recommend-text-2 --align-right --color-3" }
const _hoisted_40 = { class: "p-recommend-group-3__set" }
const _hoisted_41 = { class: "p-recommend-group-3__set-head" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-heading-2 --no-mb" }, "提出記録", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_44 = {
  key: 0,
  class: "p-recommend-group-3__set"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-recommend-group-3__set-head" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-heading-2 --no-mb" }, "メールで提出"),
  /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-text-2" }, [
    /*#__PURE__*/_createTextVNode("すでに作成済みの書類をお持ちの方は、担当者あてに"),
    /*#__PURE__*/_createElementVNode("br", { class: "u-lg-hidden" }),
    /*#__PURE__*/_createTextVNode("メールでご連絡ください。")
  ])
], -1))
const _hoisted_46 = ["href"]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "メールで提出", -1))
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-recommend-group-3__set" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "p-recommend-group-3__set-head" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-heading-2 --no-mb" }, "応募書類のサンプルダウンロード"),
    /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-text-2" }, "職種別の職務経歴書サンプルがダウンロードできます。書類作成にご活用ください。")
  ])
], -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "p-recommend-button --type-1",
  href: "https://mynavi-agent.jp/prepare/download/",
  target: "_blank",
  rel: "noopener noreferrer"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "サンプル一覧を見る")
], -1))
const _hoisted_51 = {
  class: "p-recommend-form__modal js-modal-container",
  id: "modal-rireki"
}
const _hoisted_52 = { class: "p-recommend-form__modal-card is-comment" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__modal-close js-modal-close-trigger" }, [
  /*#__PURE__*/_createElementVNode("span", null, "履歴書を提出する")
], -1))
const _hoisted_54 = { class: "c-modal_submit_advisor" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1 mt-mobile" }, "コメント(任意)", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "p-recommend-form__send" }, [
  /*#__PURE__*/_createElementVNode("span", null, "担当者へ提出する")
], -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-recommend-form__modal-close-area js-modal-close-trigger" }, null, -1))
const _hoisted_58 = {
  class: "p-recommend-form__modal js-modal-container",
  id: "modal-shokumu"
}
const _hoisted_59 = { class: "p-recommend-form__modal-card is-comment" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__modal-close js-modal-close-trigger" }, [
  /*#__PURE__*/_createElementVNode("span", null, "職務経歴書を提出する")
], -1))
const _hoisted_61 = { class: "c-modal_submit_advisor" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1 mt-mobile" }, "コメント(任意)", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "p-recommend-form__send" }, [
  /*#__PURE__*/_createElementVNode("span", null, "担当者へ提出する")
], -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-recommend-form__modal-close-area js-modal-close-trigger" }, null, -1))
const _hoisted_65 = ["onSubmit"]
const _hoisted_66 = { class: "p-recommend-form__modal-card -is-complete" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "p-recommend-form__modal-help-close" }, "閉じる", -1))
const _hoisted_68 = ["innerHTML"]
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "p-recommend-form__modal-help-close-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "閉じる")
], -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-recommend-form__modal-close-area form_advisor-area" }, null, -1))
const _hoisted_71 = { class: "l-wrapper_nav" }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_74 = [
  _hoisted_73
]

import { getSubmitAdvisorHistoryService, submitAdvisorHistoryService } from '@/api/services/trnSubmitAdvisorHistoryService';
import Loading from '@/components/Loading.vue';
import { AdvisorForm, AdvisorHistory } from '@/types/advisor';
import { onMounted, onUnmounted, ref } from 'vue';
import { FileDownload } from '@/types/request';
import { datefnsFormat } from '@/utils/dateFormat';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';
import { getMstUserInfoService } from '@/api/services/trnCareerService';
import { MstUserBasicInfo } from '@/types';
import { downloadFileService } from '@/api/services/fileService';
import { domHelperUtils } from '@/utils/domHelper';


export default /*#__PURE__*/_defineComponent({
  __name: 'SubmitAdvisorView',
  setup(__props) {

const isLoading = ref(false);
const isModalShow = ref(false);
const modalErrorMsg = ref('');
const modalRef = ref<HTMLElement | null>(null);
const validationErrorMsgLst = ref<string[]>([]);
const submitAdvisorHistories = ref<AdvisorHistory[]>([]);
const resumeComment = ref('');
const wkHistoryComment = ref('');
const mstUserBasicInfo = ref<MstUserBasicInfo>();

function scrollToTop() {
  domHelperUtils.scrollToTop();
}

const WK_HISTORY_NUM = 2;
const RESUME_NUM = 1;
const RESUME_EL_NAME = 'modal-rireki';
const WK_HISTORY_EL_NAME = 'modal-shokumu';
const WK_HISTORY = '職務経歴書'; // 2
const RESUME = '履歴書'; // 1
const VALID_FILE_TYPES = [RESUME_NUM, WK_HISTORY_NUM];




/**
 * Returns the latest insert date (YYYY-MM-DD) for the given file type.
 * If no matching history is found, returns an empty string.
 *
 * @param {number} fileType - The file type to search for
 * @returns {string} The latest insert date in 'YYYY-MM-DD' format or empty string
 */
const formatGetFileTypeDateDesc = (fileType: number): string => {
  // Filter histories by file type and sort by insertDate descending
  const latestHistory = submitAdvisorHistories.value
    .filter(history => history.fileType === fileType)
    .sort((a, b) => {
      const dateA = a.insertDate ? new Date(a.insertDate).getTime() : 0;
      const dateB = b.insertDate ? new Date(b.insertDate).getTime() : 0;
      return dateB - dateA; // Descending order
    })[0];

  // Return the date part (YYYY-MM-DD) if exists
  return latestHistory && latestHistory.insertDate
    ? ('最終提出日：' + latestHistory.insertDate.split(' ')[0])
    : '';
};

/**
 * Handles advisor form submission:
 * - Validates memo and file type before submitting
 * - Shows/hides form and loading state
 * - Handles API response and displays appropriate message
 *
 * @param {number} fileType - The type of the file to submit
 * @param {string} memo - The memo/comment to submit
 * @param {string} el - The form element selector
 */
const handleSubmitAdvisor = async (fileType: number, memo: string, el: string, type: string) => {
  // Validate inputs before submit
  validationErrorMsgLst.value = validateComment(memo);
  modalErrorMsg.value = getFileTypeValidationMessage(fileType);

  // If there are validation errors, abort submit.
  if (validationErrorMsgLst.value.length > 0 || modalErrorMsg.value.length > 0) {
    return;
  }

  isLoading.value = true;
  handleShowForm(el, false);

  const submitResponse = await submitAdvisor(fileType, memo);
  // Handle API submit error
  if (!submitResponse || (submitResponse && !submitResponse.result)) {
    modalErrorMsg.value = submitResponse.message;
  } else {
    if(type == MYPAGE_CONSTANTS.ADVISOR.RESUME_TYPE) {
      modalErrorMsg.value = MYPAGE_CONSTANTS.ADVISOR.SUBMIT_RESUME_SUCCESS;
    }
    else
    {
      modalErrorMsg.value = MYPAGE_CONSTANTS.ADVISOR.SUBMIT_HISTORY_SUCCESS;
    }
  }
  isLoading.value = false;
  isModalShow.value = true;
};

/**
 * Returns the label for the given file type.
 * File type 1: RESUME, otherwise: WK_HISTORY (2).
 *
 * @param {number} fileType - The type of the file
 * @returns {string} The formatted label for the file type
 */
const formatFileType = (fileType: number) => {
  return fileType === 1 ? RESUME : WK_HISTORY;
};

/**
* Fetches advisor submission histories and updates the state if successful.
*/
const fetchSubmitAdvisorHistories = async () => {
  isLoading.value = true;
  const res = await getSubmitAdvisorHistoryService();
  if (res) {
    submitAdvisorHistories.value = res;
  }
  isLoading.value = false;

};

/**
 * Submits an advisor form with file type and memo.
 *
 * @param {number} fileType - The type of the file to submit
 * @param {string} memo - The memo/comment to submit
 * @returns {Promise<any>} The result of the submit service
 */
const submitAdvisor = async (fileType: number, memo: string) => {
  const payload: AdvisorForm = {
    submitFileType: fileType,
    memo: memo
  };
  return submitAdvisorHistoryService(payload);
};

/**
 * Validates the memo comment according to business rules.
 * - Max 100 characters
 * - No spaces allowed
 * - No half-width Katakana
 * - No prohibited characters: \ ¥ ; < ' " "
 *
 * @param {string} memo - The comment to validate
 * @returns {string[]} Array of error messages (empty array if valid)
 */
const validateComment = (memo: string) => {
  const errors = [] as string[];

  // Maximum 100 characters
  if (memo.length > 100) {
    errors.push(MYPAGE_CONSTANTS.ADVISOR.MEMO_OVER_100);
  }
  // No space allowed
  if (/\s/.test(memo)) {
    errors.push(MYPAGE_CONSTANTS.ADVISOR.MEMO_SPACE);
  }
  // No half-width Katakana allowed
  if (/[\uFF61-\uFF9F]/.test(memo)) {
    errors.push(MYPAGE_CONSTANTS.ADVISOR.MEMO_KANA);
  }
  // No prohibited characters (\ ¥ ; < ' " ")
  if (/[\\¥;<'""]/.test(memo)) {
    errors.push(MYPAGE_CONSTANTS.ADVISOR.MEMO_PROHIBITED);
  }

  return errors;
};


/**
 * Checks if the given file type is valid.
 * Returns an empty string if valid (type 1 or 2),
 * otherwise returns a page not found error message.
 *
 * @param {number} fileType - File type number to validate
 * @returns {string} Empty string if valid, error message if invalid
 */
const getFileTypeValidationMessage = (fileType: number) => {
  return VALID_FILE_TYPES.includes(fileType) ? '' : MYPAGE_CONSTANTS.ADVISOR.PAGE_NOT_FOUND;
};

/**
 * Shows or hides the form element by toggling the 'is-active' class.
 * Resets input values if showing the form.
 *
 * @param {string} elId - The id of the form element
 * @param {boolean} isShow - Flag to show or hide the form
 */
const handleShowForm = (elId: string, isShow: boolean) => {
  const el = document.getElementById(elId);
  if (el) {
    if (isShow) {
      handleResetRefValues();
      el.classList.add('is-active');
    } else {
      el.classList.remove('is-active');
    }
  }
};

/**
 * Resets modal error message, validation error list, and comments to default values.
 */
const handleResetRefValues = () => {
  modalErrorMsg.value = '';
  validationErrorMsgLst.value = [] as string[];
  resumeComment.value = '';
  wkHistoryComment.value = '';
};

/**
 * Closes the modal message.
 * If the submission was successful, resets form values and refreshes advisor histories.
 * Otherwise, just resets form values.
 */
const handleCloseModalMessage = async () => {
  isModalShow.value = false;
  const isSubmitSuccess = (modalErrorMsg.value === MYPAGE_CONSTANTS.ADVISOR.SUBMIT_RESUME_SUCCESS || modalErrorMsg.value === MYPAGE_CONSTANTS.ADVISOR.SUBMIT_HISTORY_SUCCESS);
  handleResetRefValues();
  if (isSubmitSuccess) {
    await fetchSubmitAdvisorHistories();
  }
};

/**
 * Handles click events outside the modal.
 * Closes the modal if the click target is the designated close area.
 *
 * @param {MouseEvent} event - The mouse click event
 */
const handleClickOutSideModal = async (event: MouseEvent) => {
  const target = event.target as HTMLElement;
  const closeAreaClass = 'p-recommend-form__modal-close-area form_advisor-area';
  if (modalRef.value && target.className === closeAreaClass) {
    await handleCloseModalMessage();
  }
};

onMounted(async () => {
  document.addEventListener('click', handleClickOutSideModal);
  await fetchSubmitAdvisorHistories();
  mstUserBasicInfo.value = await getMstUserInfoService();
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutSideModal);
});


/**
 * Downloads the resume vitae as PDF or DOCX.
 * Handles filename from content-disposition header if available.
 *
 * @param isPdf - If true, download as PDF; otherwise, as DOCX.
 */
const downloadResume = async (isPdf: boolean) => {
  isLoading.value = true;
  const requestParams: FileDownload = {
    category: 'resume',
    type: isPdf ? 'pdf' : 'xlsx'
  };

  try {
    const res = await downloadFileService(requestParams);

    const stringDate = datefnsFormat(new Date(), 'yyyyMMdd_hhmmss');

    // filename
    let filename = '履歴書_' + stringDate + (isPdf ? '.pdf' : '.xlsx');
    const disposition = res.headers['content-disposition'];
    if (disposition) {
      const match = disposition.match(/filename="?([^"]+)"?/);
      if (match) filename = decodeURIComponent(match[1]);
    }
    const base64 = await blobToBase64(res.data);
    const link = document.createElement('a');
    link.href = 'data:application/octet-stream;base64,' + base64;
    link.setAttribute('download', filename);
    // Append to body before click and remove
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error('Download failed:', error);
  }
  isLoading.value = false;
};

/**
 * Downloads the curriculum vitae as PDF or DOCX.
 * Handles filename from content-disposition header if available.
 *
 * @param isPdf - If true, download as PDF; otherwise, as DOCX.
 */
const downloadCurriculumVitaeFile = async (isPdf: boolean) => {
  isLoading.value = true;
  // Prepare request parameters
  const requestParams: FileDownload = {
    category: 'curriculumvitae',
    type: isPdf ? 'pdf' : 'docx'
  };

  try {
    // Call API to get file data
    const res = await downloadFileService(requestParams);

    // Format date string for filename
    const stringDate = datefnsFormat(new Date(), 'yyyyMMdd_hhmmss');

    // Set default filename
    let filename = '職務経歴書_' + stringDate + (isPdf ? '.pdf' : '.docx');

    // Try to get filename from content-disposition header
    const disposition = res.headers['content-disposition'];
    if (disposition) {
      const match = disposition.match(/filename="?([^"]+)"?/);
      if (match) filename = decodeURIComponent(match[1]);
    }

    const base64 = await blobToBase64(res.data);
    const link = document.createElement('a');
    link.href = 'data:application/octet-stream;base64,' + base64;
    link.setAttribute('download', filename);

    // Append link to body, click to trigger download, then remove
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    // Log error if download fails
    console.error('Download failed:', error);
  }
  isLoading.value = false;

};

function blobToBase64(blob: any) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      if(reader.result) {
        const arrResult = String(reader.result).split(',');
        if(arrResult.length > 1) {
          const base64 = arrResult[1];
          resolve(base64);
        }
      }
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
      _createElementVNode("main", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/recommend/",
              "active-class": "-is-current",
              "exact-active-class": "-is-current"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/resume/",
              "active-class": "-is-current",
              "exact-active-class": "-is-current"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/resume/submitadvisor/",
              "active-class": "-is-current",
              "exact-active-class": "-is-current"
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _hoisted_11,
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("ul", _hoisted_19, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "p-recommend-download-group__buttons-button button_advisor",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (downloadResume(false)))
                        }, _hoisted_21)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "p-recommend-download-group__buttons-button button_advisor",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (downloadResume(true)))
                        }, _hoisted_23)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("button", {
                  class: "p-recommend-button --type-1 --width-set-1",
                  type: "button",
                  "data-modal-target": "modal-rireki",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (handleShowForm(RESUME_EL_NAME, true)))
                }, _hoisted_25),
                _createElementVNode("p", _hoisted_26, _toDisplayString(formatGetFileTypeDateDesc(RESUME_NUM)), 1)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createElementVNode("ul", _hoisted_32, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "p-recommend-download-group__buttons-button button_advisor",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (downloadCurriculumVitaeFile(false)))
                        }, _hoisted_34)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "p-recommend-download-group__buttons-button button_advisor",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (downloadCurriculumVitaeFile(true)))
                        }, _hoisted_36)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("button", {
                  class: "p-recommend-button --type-1 --width-set-1",
                  type: "button",
                  "data-modal-target": "modal-shokumu",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (handleShowForm(WK_HISTORY_EL_NAME, true)))
                }, _hoisted_38),
                _createElementVNode("p", _hoisted_39, _toDisplayString(formatGetFileTypeDateDesc(WK_HISTORY_NUM)), 1)
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _hoisted_42,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(submitAdvisorHistories.value, (value, k) => {
                    return (_openBlock(), _createElementBlock("p", {
                      key: k,
                      class: "p-recommend-text-2"
                    }, [
                      _createTextVNode(_toDisplayString(value.insertDate) + " " + _toDisplayString(formatFileType(value.fileType ?? 0)) + " No." + _toDisplayString(String(value.submitAdvisorHistoryId).padStart(2, '0')) + " ", 1),
                      _hoisted_43,
                      _createTextVNode(" " + _toDisplayString(value.memo), 1)
                    ]))
                  }), 128))
                ])
              ]),
              (mstUserBasicInfo.value?.email)
                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    _hoisted_45,
                    _createElementVNode("a", {
                      class: "p-recommend-button --type-1 --width-set-1",
                      href: `mailto:${mstUserBasicInfo.value?.email}`
                    }, _hoisted_48, 8, _hoisted_46)
                  ]))
                : _createCommentVNode("", true),
              _hoisted_49
            ])
          ]),
          _hoisted_50
        ]),
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, [
            _hoisted_53,
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("form", {
                class: "p-login-form",
                onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (handleSubmitAdvisor(RESUME_NUM, resumeComment.value, RESUME_EL_NAME, _unref(MYPAGE_CONSTANTS).ADVISOR.RESUME_TYPE)), ["prevent"]))
              }, [
                _hoisted_55,
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((resumeComment).value = $event)),
                  class: "p-recommend-form__textarea",
                  id: "rireki-comment",
                  placeholder: "入力してください"
                }, null, 512), [
                  [_vModelText, resumeComment.value]
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationErrorMsgLst.value, (value, k) => {
                    return (_openBlock(), _createElementBlock("p", {
                      role: "alert",
                      class: "p-login-form__error",
                      key: k
                    }, _toDisplayString(value), 1))
                  }), 128))
                ], 512), [
                  [_vShow, validationErrorMsgLst.value.length > 0]
                ]),
                _hoisted_56
              ], 32)
            ])
          ]),
          _hoisted_57
        ]),
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("div", _hoisted_59, [
            _hoisted_60,
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("form", {
                class: "p-login-form",
                onSubmit: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (handleSubmitAdvisor(WK_HISTORY_NUM, wkHistoryComment.value, WK_HISTORY_EL_NAME, _unref(MYPAGE_CONSTANTS).ADVISOR.HISTORY_TYPE)), ["prevent"]))
              }, [
                _hoisted_62,
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((wkHistoryComment).value = $event)),
                  class: "p-recommend-form__textarea",
                  id: "rireki-shokumu",
                  placeholder: "入力してください"
                }, null, 512), [
                  [_vModelText, wkHistoryComment.value]
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationErrorMsgLst.value, (value, k) => {
                    return (_openBlock(), _createElementBlock("p", {
                      role: "alert",
                      class: "p-login-form__error",
                      key: k
                    }, _toDisplayString(value), 1))
                  }), 128))
                ], 512), [
                  [_vShow, validationErrorMsgLst.value.length > 0]
                ]),
                _hoisted_63
              ], 32)
            ])
          ]),
          _hoisted_64
        ]),
        _createElementVNode("form", {
          ref_key: "modalRef",
          ref: modalRef,
          class: "p-recommend-send-documents",
          onSubmit: _withModifiers(handleCloseModalMessage, ["prevent"])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["p-recommend-form__modal js-modal-container", { 'is-active': isModalShow.value }]),
            id: "modal-message"
          }, [
            _createElementVNode("div", _hoisted_66, [
              _hoisted_67,
              _createElementVNode("p", {
                class: "p-recommend-form__text-7",
                innerHTML: modalErrorMsg.value
              }, null, 8, _hoisted_68),
              _hoisted_69
            ]),
            _hoisted_70
          ], 2)
        ], 40, _hoisted_65)
      ])
    ]),
    _createElementVNode("div", _hoisted_71, [
      _createElementVNode("a", {
        class: "g-pagetop",
        href: "#",
        "aria-label": "ページトップへ戻る",
        onClick: _withModifiers(scrollToTop, ["prevent"])
      }, _hoisted_74, 8, _hoisted_72)
    ])
  ]))
}
}

})